import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, CssBaseline } from "@mui/material";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ReviewVoiceNotes from "./pages/ReviewVoiceNotes"; // Import Review Voice Notes
import PrivateRoute from "./components/PrivateRoutes";
import EditCourse from "./pages/EditCourse"; // Adjusted import name
import UnitEditPage from "./pages/EditUnit";
import theme from "./theme"; // Assuming theme.js exports the theme
import VoiceNoteTable from "./pages/VoiceNoteTable";
import UploadCourse from "./pages/UploadCourse";
import ReviewUpgradedLAR from "./pages/ReviewUpgradedLAR";
import UpgradedLARTable from "./pages/UpgradedLARTable";
import AIFeedbacksTable from "./pages/AIFeebacksTable";
import ReviewAIFeedbacks from "./pages/ReviewAIFeedbacks";
import CourseDetailView from "./pages/ReadOnlyPages/CourseDetailView";
import UnitDetailView from "./pages/ReadOnlyPages/UnitDetailView";
import AddLevel from "./pages/AddLevel";
import AddUnit from "./pages/AddUnit";
import AddCourse from "./pages/AddCourse";
import TipOfDay from "./pages/TipOfDay";
import Characters from "./pages/Characters";
import RecordAndEarn from "./pages/RecordAndEarn";

const adminOnlyRoles = ["admin", "creator"];

const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/characters" element={<PrivateRoute element={<Characters />} />} />
            <Route path="/" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={<PrivateRoute element={<Dashboard />} />}
            />

            <Route
              path="/review-voice-notes"
              element={<PrivateRoute element={<ReviewVoiceNotes />} />}
            />
            <Route
              path="/review-ai-feedbacks"
              element={<PrivateRoute element={<ReviewAIFeedbacks />} />}
            />

            <Route
              path="/voice-notes/:courseId/:courseName"
              element={<PrivateRoute element={<VoiceNoteTable />} />}
            />

            <Route
              path="/edit/:courseId"
              element={
                <PrivateRoute requireManagedCourse element={<EditCourse />} />
              }
            />

            <Route
              path="/course-detail/:id"
              element={<PrivateRoute element={<CourseDetailView />} />}
            />

            <Route
              path="/course/:courseId/add-unit"
              element={
                <PrivateRoute requireManagedCourse element={<AddUnit />} />
              }
            />

            <Route
              path="course/:courseId/units/:unitId/edit"
              element={
                <PrivateRoute requireManagedCourse element={<UnitEditPage />} />
              }
            />

            <Route
              path="course/:courseId/units/:unitId/view"
              element={<PrivateRoute element={<UnitDetailView />} />}
            />

            <Route
              path="course/:courseId/units/:unitId/add-level"
              element={
                <PrivateRoute requireManagedCourse element={<AddLevel />} />
              }
            />

            <Route
              path="/create-course"
              element={
                <PrivateRoute
                  allowedRoles={adminOnlyRoles}
                  element={<AddCourse />}
                />
              }
            />

            <Route
              path="/upload-course"
              element={
                <PrivateRoute
                  allowedRoles={adminOnlyRoles}
                  element={<UploadCourse />}
                />
              }
            />

            <Route
              path="/review-upgraded-lar"
              element={<PrivateRoute element={<ReviewUpgradedLAR />} />}
            />

            <Route
              path="/upgraded-lar/:courseId/:courseName"
              element={<PrivateRoute element={<UpgradedLARTable />} />}
            />

            <Route
              path="/ai-feedbacks/:courseId/:courseName"
              element={<PrivateRoute element={<AIFeedbacksTable />} />}
            />

            <Route
              path="/tip-of-day"
              element={<PrivateRoute element={<TipOfDay />} />}
            />

            <Route
              path="/record-and-earn"
              element={<PrivateRoute element={<RecordAndEarn />} />}
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
